import styled from "styled-components";


export const CenteredText = styled.div`
    text-align:center;
    ${props => props.logo && `
        cursor: unset;
 `
}
`
export const WelcomeText = styled.div`
    text-align:center;
    color: #000000;
    font-size: 18px;
    font-family: 'Lato-Bold';
    margin: 8% 0 6% 0;

  `
export const BlurBackgroundImagePopup = styled.div`
position: relative;
// height: 100%;
min-height:70%;
width:100%;
margin:0 auto;
border-radius: 5px;
border: 1px solid rgba(255,255,255,1); 
margin-top: 0px;
overflow:hidden;
box-shadow:rgba(0, 0, 0, 0.19) 0px 3px 3px 0px;

@media screen and (max-width: 750px){
  {
    min-height:55%;
  }
}

: after {
width: 100%;
content: "";
position:absolute;
top: 0;
left: 0;
height: 100%;
background: url(${props => props.background});
background-repeat: no-repeat;
background-size: 100% 100%;
filter: blur(8px);
-webkit-filter: blur(5px);
z-index: -1;
}
`

export const BlurBackgroundContainer = styled.div`
    position: relative;
    height: ${props => props?.lifemedia ? "" : "65%"};
    width: ${props => props?.mediagallery ? "149px" : ""};
    border-radius: ${props => props?.pc ? "20px" : "5px"};
    border: 1px solid rgba(255,255,255,1); 
    margin-top: ${props => props?.imagemedia || props?.lifemedia ? "0px" : "20px"};
    overflow:hidden;

   : after {
    width: 100%;
    content: "";
    position:absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: url(${props => props.background});
    background-repeat: no-repeat;
    background-size: 100% 100%;
    filter: blur(8px);
    -webkit-filter: blur(5px);
    z-index: -1;
  }
    @media screen and (max-width: 760px){
    width: ${props => props?.mediagallery ? "130px" : ""};
    }
` 

export const ErrorSpan = styled.span`
`